<template>
  <div>
    <div v-if="loading" class="br-muted">Загружаем правила…</div>
    <div v-else-if="error" class="br-error">
      {{ error }}
      <button class="btn btn-sm btn-outline-secondary" @click="load">Повторить</button>
    </div>
    <div v-else-if="!records.length" class="br-muted">Нет записи в балансировщике</div>
    <div v-else>
      <div v-for="record in records" :key="record.groupId" class="br-group">
        <div class="br-group-name">Группа: {{ record.name || '(без имени)' }}</div>
        <div v-for="variant in ['A', 'B']" :key="variant">
          <b>Правила {{ variant }}</b>
          <table class="table table-sm br-table">
            <thead>
              <tr><th style="width:35%">CSS-селектор</th><th style="width:12%">Тип</th><th>Значение</th></tr>
            </thead>
            <tbody>
              <tr v-for="(rule, idx) in rulesOf(record, variant)" :key="idx">
                <td>{{ rule.selector }}</td>
                <td>{{ rule.type }}</td>
                <td><pre class="br-value">{{ rule.value }}</pre></td>
              </tr>
            </tbody>
          </table>
          <div v-if="!rulesOf(record, variant).length" class="br-muted">
            Нет правил замены текста и HTML
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBalansirIndex, normalizePhrase, extractReplaceRules } from '@/utils/balansirIndex';

export default {
  name: 'BalansirRules',
  props: {
    phrase: { type: String, required: true },
  },
  data() {
    return { index: null, loading: false, error: '' };
  },
  computed: {
    records() {
      if (!this.index) return [];
      return this.index.get(normalizePhrase(this.phrase)) || [];
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      this.error = '';
      getBalansirIndex()
        .then(index => { this.index = index; })
        .catch(() => { this.error = 'Не удалось загрузить данные балансировщика.'; })
        .then(() => { this.loading = false; });
    },
    rulesOf(record, variant) {
      return extractReplaceRules(variant === 'A' ? record.blockReWriteA : record.blockReWriteB);
    },
  },
};
</script>

<style scoped>
.br-muted { color: var(--text-muted); font-size: .9em; }
.br-group { margin-bottom: 1em; }
.br-group-name { font-weight: 600; margin-bottom: .4em; }
.br-table { margin-bottom: .3em; }
.br-value {
  white-space: pre-wrap; word-break: break-word;
  max-height: 12em; overflow-y: auto; margin: 0; font-size: .85em;
}
.br-error { color: var(--cell-100); display: flex; gap: .6em; align-items: center; }
</style>
